<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator :color="'#000'" />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
const { lenis } = useLenis({
  anchors: true,
})
provide('lenis', lenis)
</script>
